import React from "react";
import { Box, Typography } from "@mui/material";
import TriggeredFaultBreakdownChart from "./TriggeredFaultBreakdownChart";
import ResolutionDurationBreakdownChart from "./ResolutionDurationBreakdownChart";

const BmsFaultsInsights = ({ startDate, endDate, globalFilters = {} }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      {/* Section Header */}
      <Box>
        <Typography
          variant="fw400s20c000"
          sx={{
            lineHeight: "28px",
            fontWeight: 300,
          }}
        >
          Insights
        </Typography>
      </Box>

      {/* Charts Container */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TriggeredFaultBreakdownChart
          startDate={startDate}
          endDate={endDate}
          hierarchicalLocation={globalFilters?.hierarchicalLocation}
          alertCategories={globalFilters?.alertCategories}
          operationalStatus={globalFilters?.operationalStatus}
          globalFilters={globalFilters}
        />
        <ResolutionDurationBreakdownChart
          startDate={startDate}
          endDate={endDate}
          hierarchicalLocation={globalFilters?.hierarchicalLocation}
          alertCategories={globalFilters?.alertCategories}
          operationalStatus={globalFilters?.operationalStatus}
          globalFilters={globalFilters}
        />
      </Box>
    </Box>
  );
};

export default BmsFaultsInsights;
